import React, { useState } from 'react';
import { Toolbar, Grid, Stack, MenuItem, Button, IconButton, Paper, InputAdornment } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import { Link, useNavigate } from "react-router-dom"
import { useFormik } from 'formik';
import get from "lodash/get";
import CloseIcon from '@mui/icons-material/Close';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useCanView } from "../../../config/hook/UserPermissions";
import Alert from "../../../components/form/Alert";

import InputText from "../../../components/form/InputText";

const ToolbarComponent = ({ setFilter, __, reload, isLoading }) => {
    const canView = useCanView();
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const navigate = useNavigate();

    const onSubmit = (values) => {
        let Filters = "";

        if (!!values.name) { Filters = `clientInvoice.name@=${values.name}` }
        if (!!values.idInvoice) { Filters = `${!!Filters ? `${Filters},` : ""}idInvoice==${values.idInvoice}` }
        // en el get, la conteo de detalle

        // en el de ordenes, agregar total, debe ser editable como el cantidad.
        switch (get(values, "idInvoiceStatus")) {
            case 1: { Filters = `${!!Filters ? `${Filters},` : ""}idInvoiceStatus==1` }; break;
            case 2: { Filters = `${!!Filters ? `${Filters},` : ""}idInvoiceStatus==2` }; break;
            default: break;
        }
        setFilter(Filters)
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const idInvoiceStatus = [
        {
            value: 0,
            name: __(`idInvoiceStatus.all`),
        },
        {
            value: 1,
            name: __(`idInvoiceStatus.1`),
        },
        {
            value: 2,
            name: __(`idInvoiceStatus.2`),
        },
    ]

    const formik = useFormik({
        initialValues: {
            idInvoice: "",
            name: "",
            idInvoiceStatus: get(idInvoiceStatus, "[0].value"),
        },
        onSubmit,
    });

    const onClear = (field) => async () => {
        await formik.setFieldValue(field, "")
        formik.submitForm()
    }

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-start", md: "flex-end" }}>
                    <Grid item xs={12} md={4} lg={3} xl={3}>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button className='w-[200px] min-w-[150px]' startIcon={<AutorenewIcon />} variant="contained" color="secondary" onClick={() => {
                                if (canView("TRANSACCIONES/FACTURACIÓN CLIENTE", "add")) {
                                    navigate("new");
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para generar facturas de clientes.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>{__(`toolbar.btn`)}</Button>
                            <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
                        </Stack>
                    </Grid>
                </Grid>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent